<template>
  <div class="body-wrap">
    <request-pin v-if="activeView === 'pin'" @sendPin="(pin) => (sendPin(pin))"/>
    
    <div v-if="activeView === 'commercials' || activeView === 'main' || activeView === 'error'" class="container-fluid homescreen-ct">
      <commercial-screen :shown="activeView === 'commercials' && !transitioning && languagesLoaded" @screenClick="handleHideCommercial()" />
      
      <header-row v-if="activeView === 'main' || activeView === 'error' && !transitioning" :language="language" @changeLanguage="changeLanguage()" />
      <template v-if="activeView === 'main' && !transitioning">
        <main-screen :qrcode="qrCode" />
        <qr-code :qrcode="qrCode" />
      </template>
     
      <error-screen v-if="activeView === 'error' && !transitioning" />
    </div>

    <input-screen v-else-if="activeView === 'input'"
                  @waitingForQr="(toError) => sessionFinish(toError)"
                  @sendFinish="endSessionSignal()"
                  :add-can="data.can"
                  :add-tetrapack="data.tetrapack"
                  :add-pet="data.pet" :user="user"
                  :add-battery="data.battery"
                  :add-vape="data.vape"
                  :add-vape-salt="data.vape_salt"
                  :return-item="data.returnItem"
                  :item-stuck="data.itemStuck"
                  :session-number="sessionNumber"
                  :values="values"
                  :session-totals="sessionValues"
                  :session-points="sessionPoints"
                  :device-ready="deviceReadyState"
                  :item-failed="itemFailed"
                  :session-timeout="timeout" />
    <!-- <logged-navigation @eventLaunched="(type)=> {this.makeEvent(type)}"/> -->
  </div>
</template>

<script>
import MainScreen from '@/components/Main';
import ErrorScreen from '@/components/Error';
import InputScreen from '@/components/Input';
import HeaderRow from '@/components/Header';
import QrCode from '@/components/QrCode';
import CommercialScreen from '@/components/Commercials';
import LoggedNavigation from '@/components/LoggedNavigation';
import { mapActions, mapGetters } from 'vuex';
import VuexTypes from '@/store/types/index';
import Vue from 'vue';
import {preventDrag} from '@/assets/js/base';
import RequestPin from '@/components/PinRequest';

const TranslationsTypes = VuexTypes.translations;
const DepositTypes = VuexTypes.depositTypes;

export default {
  components: {
    MainScreen,
    ErrorScreen,
    InputScreen,
    LoggedNavigation,
    CommercialScreen,
    HeaderRow,
    QrCode,
    RequestPin
  },

  data() {
    return {
      isLoading: false,
      activeView: 'commercials', // ['pin', 'main', 'error', 'input', 'commercials']
      language: 'lv',
      data: {
          tetrapack: 0,
          can: 0,
          pet: 0,
          battery: 0,
          vape: 0,
          vape_salt: 0,
          returnItem: 0,
          itemStuck: 0
      },
      values: {
      },
      user: {
          points: 0,
          name: ''
      },
      sessionValues: [],
      sessionPoints: 0,
      transitioning: false,
      sessionNumber: 0,
      deviceReadyState: true,
      sessionId: null,
      socketActive: false,
      qrCode: null,
      waitTimer: null,
      itemFailed: 0,
      goodbyeTime: false,
      qrCodeChanged: false,
      toError: false,
      timeout: 0,
      commercialTimer: null,
      isError: true,
      errorNeedsProcessing: false,
      codeUpdated: false,
      languagesLoaded: false,
      ignoreAdjacentSignals: false
    };
  },
  computed: {
    ...mapGetters('Translations', [
      'translations',
    ]),
    ...mapGetters('DepositTypes', [
      'depositTypesList',
    ]),
  },
  mounted() {
    //assume the JS file is loaded between created() and mounted() hooks
    let that = this;
    setTimeout(function(e) {
      Vue.set(that, 'languagesLoaded', true);
    }, 100);
    this.connectionStatus();
    preventDrag();
  },
  created() {
    this.TRANSLATIONS('lv');
  },
  watch: {
    socketActive: function (val, oldVal) {
      if (val) {
        this.launchListener()
      }
    },
    activeView: function (val, oldVal) {
      this.preventRerenderDrag();
    },
    goodbyeTime: function (val, oldVal) {
      if (val === false && oldVal) {
        if (this.qrCodeChanged || this.toError) {
          this.manageSessionProcessed(false);
        }
      }
    },
    qrCodeChanged: function (val, oldVal) {
      if (val && !this.goodbyeTime) {
        this.manageSessionProcessed(true);
      }
    },
    qrCode: function (val, oldVal) {
      Vue.set(this, 'qrCodeChanged', true);
    }
  },
  methods: {
    ...mapActions({
      TRANSLATIONS: 'Translations/' + TranslationsTypes.TRANSLATIONS,
      DEPOSIT_TYPES_LIST: 'DepositTypes/' + DepositTypes.DEPOSIT_TYPES_LIST,
    }),
    setAbilities(abilities) {
      if (abilities && abilities.length > 0) {
        ability.update(abilities);
      }
    },
    manageSessionProcessed(fromQrChanged) {
      Vue.set(this, 'qrCodeChanged', false);
      if (this.toError) {
        this.setIgnore();
        if (this.$socket.readyState === 1) {
          this.$socket.sendObj({message: 'sessionProcessed'});
        }
        Vue.set(this, 'toError', false);
        Vue.set(this, 'isError', true);
        this.toScreen('commercials');
      } else {
        this.setIgnore();
        if (fromQrChanged) {
          Vue.set(this, 'codeUpdated', true);
        } else {
          Vue.set(this, 'isError', false);
        }
        if (this.$socket.readyState === 1) {
          this.$socket.sendObj({message: 'sessionProcessed'});
        }
        this.toScreen('commercials');
      }
    },
    toScreen(screen) {
      Vue.set(this, 'activeView', screen);
    },
    setIgnore() {
      let that = this;
      Vue.set(this, 'ignoreAdjacentSignals', true);
      setTimeout(function (e) {
        Vue.set(that, 'ignoreAdjacentSignals', false);
      }, 5000);
    },
    changeLanguage() {
      let language = this.language === 'lv' ? 'en' : 'lv';
      Vue.set(this, 'language', language);
      this.TRANSLATIONS(language);
    },
    makeEvent(type) {
        let message = '';
        let messageArray = [];
        let rand = 0;
        switch (type) {
            case 'QR':
                messageArray = ['{"message":"qr","value":"6-fvz/F/6yJ7dvY3aBmc4UN4CGLBKh4jmbNHAmey5vuqg="}', '{"message":"qr","value":"6-fvz/F/6yJ7dvY3aBmc4UN4CGLBKh4jmbNHAmejombo="}'];
                rand = Math.floor(Math.random() * Math.floor(2));
                message = messageArray[rand];
                break;
            case 'item':
                messageArray = [];
                this.depositTypesList.data.forEach((type) => {
                  //if (type.type_name !== 'vape' && type.type_name !== 'vape_salt') { return; }
                  messageArray.push(`{ "item": "${type.type_name}", "message":"depositItem" }`);
                });

                rand = Math.floor(Math.random() * Math.floor(messageArray.length));
                console.log('Simulate item', messageArray[rand]);
                message = messageArray[rand];
                break;
            case 'returnItem':
                message = '{"item":"returnItem","message":"depositItem"}';
                break;
            case 'requestPin':
                message = '{"message":"requestPin"}';
                break;
            case 'sessionStart':
                let depositTypes = '';
                this.depositTypesList.data.forEach((type) => {
                  console.log('typeee', type);
                  depositTypes += `"${type.type_name}":${type.credit_value},`
                });
                depositTypes = depositTypes.substring(0, depositTypes.length - 1);

                message = '{"message":"sessionStart", "sessionId":468,"sessionInfo":{"deposit_types":{' + depositTypes + '}, "user":{"credit":0,"id":19,"lang":"lv","name":"Sergejs I"}}}';
                break;
            case 'cancelItem':
                message = '{"message":"returnItem", "item":"tetrapack"}';
                break;
            case 'deviceIsReady':
                message = '{"message":"deviceIsReady","ready":true}';
                break;
            case 'deviceIsNotReady':
                message = '{"message":"deviceIsReady","ready":false}';
                break;
            case 'personIsInFront':
                message = '{"message":"personInFrontOfDevice","isInFront":true}';
                break;
            case 'systemFailedFalse':
                message = '{"message":"systemFailed","failed":false}';
                break;
        }
        this.handleReceiveEvent(message);
    },
    sendPin(pin) {
      Vue.set(this, 'activeView', 'commercials');
      if (this.$socket.readyState === 1) {
        this.$socket.sendObj({message: 'pin', data: pin});
      }
    },
    connectionStatus() {
      let that = this;
      if (this.$options.sockets.onclose) {
        delete this.$options.sockets.onclose;
      }
      if (this.$socket.readyState === 1) {
        console.log('sending');
        this.$socket.sendObj({status: 'connection established'});
        Vue.set(this, 'socketActive', true);
      } else {
        setTimeout(() => {
          console.log('waiting');
          that.connectionStatus()
        }, 4000)
      }
    },
    preventRerenderDrag() {
      preventDrag();
    },
    handleReceiveEvent(event) {
        // console.log(event);

        let content = JSON.parse(event);
        switch (content.message) {
            case 'qr':
                this.handleQrCode(content.value);
                break;
            case 'sessionStart':
                this.handleSessionStart(content.sessionId, content.sessionInfo);
                break;
            case 'depositItem':
                this.handleItem(content.item);
                break;
            case 'deviceIsReady':
                this.handleDeviceReady(content.ready);
                break;
            case 'systemFailed':
                this.handleSystemFailed(content.failed);
                break;
            case 'requestPin':
                this.handleRequestPin();
                break;
            case 'sessionTimeout':
                this.handleSessionTimeout();
                break;
            case 'personInFrontOfDevice':
                this.handleIsAdjacent(content.isInFront);
                break;
            case 'returnItem':
                this.handleItemStuck(content.item);
              break;
            default:
                console.log('uncaught event: ' + event);
                return;
        }
        this.emitResponse(content.message)
    },
    handleRequestPin(){
      if (this.commercialTimer) {
        clearTimeout(this.commercialTimer);
      }
      Vue.set(this, 'activeView', 'pin');
    },
    handleIsAdjacent(isInFront) {
        if (isInFront && !this.ignoreAdjacentSignals) {
          if (this.activeView === 'commercials') {
            this.handleHideCommercial();
          } else if (this.activeView !== 'input' && this.activeView !== 'pin') {
            this.resetCommercialTimer();
          }
        }
    },
    handleItemStuck(item) {
        let index = this.sessionValues.findIndex((valueItem) => {
            return (valueItem.type === item)
        });
        //for mistake handling/crash prevention
        if (index < 0) {
          return;
        }
        Vue.set(this.data, 'itemStuck', this.data.itemStuck + 1); //used to launch animations
        this.sessionValues[index].amount--;
        this.sessionValues[index].points -= this.values[item];
        if (this.sessionValues[index].amount === 0) {
          this.sessionValues.splice(index, 1);
        }
        Vue.set(this.user, 'points', this.user.points - this.values[item]);
        Vue.set(this, 'sessionPoints', this.sessionPoints - this.values[item]);
    },
    resetCommercialTimer() {
        let that = this;
        if (this.commercialTimer) {
          clearTimeout(this.commercialTimer);
        }
        this.commercialTimer = setTimeout(function (e){
          if (that.activeView !== 'input') {
            if (!that.qrCode) {
              Vue.set(that, 'activeView', 'commercials');
            }
          }
        }, 20000);
    },
    handleSystemFailed(failed) {
        if (failed && !this.isError) {
          if (this.sessionId) {
            Vue.set(this, 'errorNeedsProcessing', true);
            Vue.set(this, 'itemFailed', this.itemFailed + 1);
          } else {
            this.clearData();
            Vue.set(this, 'isError', true);
            this.handleHideCommercial();
          }
        } else if (!failed && this.isError && this.codeUpdated) {
          Vue.set(this, 'isError', false);
          Vue.set(this, 'codeUpdated', false);
          this.handleHideCommercial();
        } else if (!failed && this.errorNeedsProcessing) {
          this.errorNeedsProcessing = false;
        }
    },
    handleDeviceReady(state) {
        Vue.set(this, 'deviceReadyState', state);
        this.DEPOSIT_TYPES_LIST();
    },
    handleSessionTimeout() {
        Vue.set(this, 'timeout', this.timeout + 1);
    },
    handleItem(item) {
        Vue.set(this.data, item, this.data[item] + 1); //used to launch animations
        if (item === 'returnItem') { return };
        if (this.sessionValues.some(valueSet => valueSet.type === item)) {
            let index = this.sessionValues.findIndex((valueItem) => {
                return (valueItem.type === item)
            });
            this.sessionValues[index].amount++;
            this.sessionValues[index].points += this.values[item];
        } else {
            let newType = {
                type: item,
                amount: 1,
                points: this.values[item]
            }
            let oldArray = this.sessionValues;
            oldArray.push(newType);
            Vue.set(this, 'sessionValues', oldArray);
        }
        
        Vue.set(this.user, 'points', this.user.points + this.values[item]);
        Vue.set(this, 'sessionPoints', this.sessionPoints + this.values[item]);
    },
    handleQrCode(value) {
        Vue.set(this, 'qrCode', value);
        this.handleHideCommercial();
    },
    handleSessionStart(sessionId, sessionInfo) {
        console.log('sessionInfo.deposit_types', sessionInfo.deposit_types);
        Vue.set(this, 'values', sessionInfo.deposit_types);
        Vue.set(this, 'user', {name: sessionInfo.user.name, points: sessionInfo.user.credit});
        if (this.commercialTimer) {
          clearTimeout(this.commercialTimer);
        }

        // in case things were thrown in without session
        this.clearPointData();

        if (this.language !== sessionInfo.user.lang) {
            this.changeLanguage();
        }
        Vue.set(this, 'sessionId', sessionId);
        Vue.set(this, 'sessionNumber', this.sessionNumber + 1);
        this.toScreen('input');
    },
    sessionFinish(toError) {
        if (toError && this.errorNeedsProcessing) {
          Vue.set(this, 'toError', true);
        }
        let that = this;
        setTimeout(function(e) {
          Vue.set(that, 'goodbyeTime', false)
        }, 3000);
        this.clearData();
    },
    endSessionSignal() {
        this.goodbyeTime = true;
        if (this.socketActive) {
          this.$socket.sendObj({endSession: this.sessionId});
        }
    },
    emitResponse (type) {
        if (this.socketActive) {
          this.$socket.sendObj({processed: type});
        }
    },
    handleHideCommercial() {
        let that = this;
        Vue.set(this, 'transitioning', true);
        setTimeout(function (e) {
          Vue.set(that, 'transitioning', false);
        }, 250);
        Vue.set(this, 'activeView', this.isError ? 'error' : 'main');
        this.resetCommercialTimer();
    },
    launchListener() {
      this.$options.sockets.onmessage = (data) => {
        if (data) {
            this.handleReceiveEvent(data.data);
        }
      }
      this.$options.sockets.onclose = (data) => {
        delete this.$options.sockets.onmessage;
        this.clearData();
        Vue.set(this, 'isError', true);
        Vue.set(this, 'activeView', 'commercials');
        Vue.set(this, 'socketActive', false);
        this.connectionStatus();
      }
    },
    clearData() {
        this.values = {};
        this.clearPointData();
        this.data = {tetrapack: 0, pet: 0, can: 0, battery: 0, vape: 0, vape_salt: 0, returnItem: 0, itemStuck: 0};
        Vue.set(this, 'user', {name: '', points: 0});
        Vue.set(this, 'sessionId', null);
        Vue.set(this, 'timeout', 0);
        return true;
    },
    clearPointData() {
      Vue.set(this, 'sessionValues', []);
      Vue.set(this, 'sessionPoints', 0);
    }
  }
}
</script>
